export default __webpack_public_path__ + "static/media/Img.5cf870d4.jpg";